export const branchConfig = {
  branchId: "guro",

  // 미들웨어 설정 (#878 — middleware.js 에 박혀 있던 옵션).
  // 쿠키 domain 은 한 번 심기면 리버트해도 브라우저에 남는다 — 값을 그대로 옮겼다.
  middleware: {
    localePrefixes: ["en", "ja", "zh", "th"],
  },

  // 홈 빠른상담 설정 (#874 — homeClient 에 박혀 있던 값).
  homeQuickConsult: {
    enableIdentity: true,
    // 빠른상담 전송 경로 — 현재 코드에서 읽었다 (#874).
    submitVia: "chart",
  },
  // 홈 구조화 데이터의 기관명 (#874).
  homeJsonLd: { orgNameKo: "끗 한의원 구로디지털단지역", orgNameEn: "Guro KKEUT Clinic (Guro Digital Complex Station)" },

  // 비급여 안내의 병원명 표기 (#872 — 페이지에 박혀 있던 값).
  // 지금은 읽는 곳이 없다 (#892). 공유본이 6월에 상단 노출을 지웠다 —
  // 다시 노출하기로 하면 쓸 값이라 남겨 둔다.
  // branchTitle·titleTail 과 섞여 있어 유도할 수 없어 그대로 옮겼다.
  uncoveredFeesHospital: {"ko":"구로본점 끗 한의원","en":"Guro KKEUT Korean Clinic","ja":"九老 KKEUT韓医院","zh":"九老 KKEUT韩医院"},

  // 연혁 3번째 카드(도약) — 「신규 고객 60%가 지인 소개」만 뺀다, 만족도는 그대로 (#1147, 천안불당 #687 방식)
  historyItemDescPatches: {
    2: {
      ko: "만족도 99.8%. 믿고 찾아주시는 성원에 힘입어, 이제 끗 한의원은 전국(강남, 대전, 부산, 대구, 광주, 홍대 등)으로 나아갑니다. 지역은 달라도 '끗'만의 고집스러운 정성은 같습니다.",
      en: "A satisfaction rate of 99.8%. Thanks to your trust and support, KKEUT is now expanding nationwide (Gangnam, Daejeon, Busan, Daegu, Gwangju, Hongdae and more). The regions differ, but KKEUT’s stubborn dedication remains the same.",
      ja: "満足度99.8%。信じて訪れてくださる声援に支えられ、今やクッ韓方医院は全国(江南、大田、釜山、大邱、光州、弘大など)へと進みます。地域は違っても「クッ」だけのこだわりの真心は同じです。",
      zh: "满意度99.8%。依靠信任并前来的支持，现在KKEUT韩医院正在走向全国(江南、大田、釜山、大邱、光州、弘大等)。虽然地区不同，但唯有“KKEUT”固执的真心是一样的。",
      th: "ความพึงพอใจ 99.8% ด้วยแรงสนับสนุนที่เชื่อมั่น ตอนนี้ KKEUT Clinic กำลังก้าวไปทั่วประเทศ (กังนัม, แทจอน, ปูซาน, แทกู, กวางจู, ฮงแด ฯลฯ) แม้พื้นที่ต่างกัน แต่ความจริงใจที่ดื้อรั้นของ ‘KKEUT’ ยังคงเหมือนเดิม",
    },
  },

  // 푸터의 지점 표기 (#861 — 래퍼에 박혀 있던 값).
  branchTitle: {"ko":"구로본점 끗 한의원","en":"KKEUT Guro","ja":"KKEUT韓医院（九老）","zh":"KKEUT韩医院（九老）","th":"KKEUT คูโร"},
  // 홈 소셜 섹션 (#861). 기존 social 키와 쓰임이 달라 분리한다.
  socialShowcase: {
    overline: { ko: "끗 한의원 구로점" },
    youtube: "https://www.youtube.com/@kkeutclinic-guro",
    instagram: "https://www.instagram.com/kkeut_clinic_guro",
  },
  fallbackDomain: "https://www.kkeutclinic.co.kr",
  // 외국어 홈 검색 제목 — 지역 + 분야 + 병원명. 한국어는 titleTail 그대로 (titleTail 은 다른 페이지 제목 끝에도 붙어서 따로 둔다).
  homeTitle: {
    en: "Guro, Seoul Skin Clinic | KKEUT Korean Medicine Clinic",
    ja: "ソウル九老デジタル団地 肌管理・スキンクリニック | KKEUT韓医院",
    zh: "首尔九老数码园区 皮肤管理诊所 | KKEUT韩医院",
    th: "คลินิกผิว กูโร โซล | KKEUT Korean Medicine Clinic",
  },
  titleTail: {
    ko: "구로본점 끗 한의원 구로디지털단지역",
    en: "Korea KKEUT Korean Clinic Seoul Guro Digital Complex",
    ja: "韓国 KKEUT韓医院 ソウル 九老デジタル団地駅",
    zh: "韩国 KKEUT韩医院 首尔 九老数码园区站",
    th: "เกาหลี KKEUT Korean Clinic โซล กูโร ดิจิทัล คอมเพล็กซ์",
  },
  areaPrefix: {
    ko: "구로 구디역 구로디지털단지역 가산 독산역 광명 철산역 가산디지털단지역 신도림역 서울대입구역 신림역 영등포역",
    en: "Seoul Guro, Gasan, Doksan, Cheolsan, Gwangmyeong, Guro Digital Complex, Gasan Digital Complex, Namguro",
    ja: "ソウル 九老（グロ）、加山（カサン）、独山（トクサン）、鉄山（チョルサン）、光明（クァンミョン）、九老デジタル団地、加山デジタル団地、南九老",
    zh: "首尔 九老、加山、独山、铁山、光明、九老数码园区、加山数码园区、南九老",
    th: "โซล กูโร กาซัน ด็อกซัน ชอลซัน กวังมยอง กูโร ดิจิทัล คอมเพล็กซ์ กาซัน ดิจิทัล คอมเพล็กซ์ นัมกูโร",
  },
  naver: "11aeebaa1b78d629deb7252b952bc514575d05c0",
  google: "XF8flFzVlpsFvV77lP0fpAZXzczItrs03Mtzuoa4d4U",
  // 끗차트(EMR) 연동 스위치 — reserveChange/page.jsx 가 이 파일(@/lib/branchConfig)을 읽어 분기.
  // config/branch.js 의 값과 항상 동일하게 유지할 것.
  chartIntegration: {
    enabled: true,
  },
  homeDesc: {
    ko: "인근 한의원. 구로 리프팅·제모·여드름·피부과 시술부터 다이어트/약침 관리까지 한 번에 상담하세요.",
    en: "Korean medicine skin clinic in Guro, Seoul — skin, weight and lifting care. Diet programs, lifting, acupuncture, laser toning, hair removal, acne care, skin boosters and more.",
    ja: "韓方クリニック。ダイエット、リフティング、鍼、レーザートーニング、脱毛、ニキビケア、スキンブースターなど。",
    zh: "韩医诊所：减肥、提升、针灸、激光焕肤、脱毛、痘痘护理、肌肤补剂等项目。",
    th: "คลินิกแพทย์แผนเกาหลีที่เน้นการดูแลผิวพรรณ ลดน้ำหนัก และยกกระชับ ให้บริการโปรแกรมลดน้ำหนัก การยกกระชับ ฝังเข็ม เลเซอร์โทนนิ่ง กำจัดขน รักษาสิว และสกินบูสเตอร์",
  },
  homeKeywords: {
    ko: ["구로한의원","구로디지털단지역한의원","관악구한의원","구로 다이어트","피부과","리프팅","약침","레이저토닝","제모","여드름","스킨부스터","공진단","리쥬란","보톡스","필러"],
    en: ["KKEUT Clinic","Guro clinic","Korean medicine","diet program","lifting","acupuncture","laser toning","hair removal","acne","skin booster","botox","filler"],
    ja: ["KKEUT クリニック","九老 クリニック","韓方","ダイエット","リフティング","鍼","レーザートーニング","脱毛","ニキビ","スキンブースター","ボトックス","フィラー"],
    zh: ["首尔 九老、加山、独山、铁山、光明、九老数码园区、加山数码园区、南九老","痘坑","痘痘","疤痕","提升","肉毒","填充","脱毛","皮肤管理","减肥","首尔皮肤科","韩国皮肤科"],
    th: ["คลินิกกูโรดิจิทัลคอมเพล็กซ์","คลินิกกูโร","รักษาสิว","รักษาหลุมสิว","เลเซอร์ยกกระชับ","ยกกระชับผิว","โบท็อกซ์","ฟิลเลอร์","กำจัดขน","ดูแลผิว","ลดน้ำหนัก","คลินิกผิวหนังโซล","คลินิกเกาหลี"],
  },
  policyHospitalName: {
    ko: "구로본점 끗 한의원",
    en: "Guro",
    ja: "九老",
    zh: "九老",
    th: "สาขากูโร",
  },

  // 화면별 SEO 문구 — 단일앱에서는 파일이 하나뿐이라 지점 데이터는
  // 전부 설정으로 와야 한다 (#846).
  seo: {
    networkLayout: {
      sameAs: [
      "https://blog.naver.com/kkeutclinic",
      "https://www.instagram.com/kkeut_clinic.guro",
      "https://tv.naver.com/kkeutclinicguro",
      "https://www.youtube.com/@guro_kkeut_clinic",
      ],
      i18n: {
      title: {
        ko: "끗 한의원, 한 끗 차이의 아름다움",
        en: "KKEUT Clinic — The Beauty in Detail",
        ja: "KKEUT 韓医院 — ひとすじ違いの美しさ",
        zh: "KKEUT韩医院 — 一线之差的美",
      },
      desc: {
        ko: "전국 피부·다이어트·리프팅 전문 한의원 네트워크",
        en: "Nationwide Korean medicine clinic network for skin, diet, and lifting",
        ja: "全国の皮膚・ダイエット・リフティング専門 韓方クリニック ネットワーク",
        zh: "全国皮肤/减肥/提升 专业韩医诊所网络",
      },
      ogLocale: { ko: "ko_KR", en: "en_US", ja: "ja_JP", zh: "zh_CN" },
    },
    },
    beforeDetail: {
      // 이 지점만 태국어까지 넘기고 있었다 — 페이지 인라인에서 옮김 (#861).
      supported: ["ko", "en", "ja", "zh", "th"],
  defaultKeywords: {
    ko: [
      "전후사진",
      "피부과",
      "리프팅",
      "시술",
      "보톡스",
      "필러",
    ],
    en: [
      "before and after",
      "dermatology",
      "lifting",
      "treatment",
      "botox",
      "filler",
    ],
    ja: [
      "ビフォーアフター",
      "皮膚科",
      "リフティング",
      "施術",
      "ボトックス",
      "フィラー",
    ],
    zh: [
      "前后对比",
      "皮肤科",
      "提升",
      "治疗",
      "肉毒",
      "填充",
    ],
    th: [
      "ก่อนและหลัง",
      "ผิวหนัง",
      "ยกกระชับ",
      "ทรีตเมนต์",
      "โบท็อกซ์",
      "ฟิลเลอร์",
    ],
  },
    },
    cart: {
      kwMap: {
  ko: [
    "장바구니", "시술 예약", "시술 선택", "구로 슈링크", "인모드", "여드름", "점제거",
    "제모", "리프팅", "피부 시술", "보톡스", "한방 시술", "다이어트", "윤곽주사",
    "지방분해", "피부과 예약", "한의원 예약",
  ],
  en: [
    "cart", "treatment booking", "selection", "Shurink", "InMode", "acne", "mole removal",
    "hair removal", "lifting", "botox", "diet", "clinic booking",
  ],
  ja: [
    "カート", "施術予約", "選択", "シュリンク", "InMode", "ニキビ", "ホクロ除去",
    "脱毛", "リフティング", "ボトックス", "ダイエット", "予約",
  ],
  zh: [
    "购物车", "项目预约", "选择", "舒灵克", "InMode", "痘痘", "祛痣",
    "脱毛", "提升", "肉毒", "减肥", "预约",
  ],
  th: [
    "ตะกร้าสินค้า", "จองคิว", "เลือกรายการ", "Shurink", "InMode", "สิว", "กำจัดไฝ",
    "กำจัดขน", "ลิฟติ้ง", "โบท็อกซ์", "ลดน้ำหนัก", "จองคลินิก"
  ],
},
    },
    skinNoteDetail: {
      // 이 지점만 태국어까지 넘기고 있었다 — 페이지 인라인에서 옮김 (#861).
      supported: ["ko", "en", "ja", "zh", "th"],
  baseTitle: {
    ko: "시술 노트 | 구로본점 끗 한의원",
    en: "Procedure Notes | KKEUT Korean Clinic Seoul Guro",
    ja: "施術ノート | KKEUT韓医院 ソウル 九老",
    zh: "项目笔记 | KKEUT韩医院 首尔 九老",
    th: "Procedure Notes | KKEUT Clinic Seoul Guro",
  },
  baseDesc: {
    ko: "시술 원리, 전후 관리, 케이스 인사이트를 정리한 시술 노트 상세 페이지입니다.",
    en: "Procedure notes with principles, aftercare, and case insights.",
    ja: "施術原理、アフターケア、ケースの洞察をまとめた詳細ページです。",
    zh: "项目原理、术后护理与案例洞见的详细页面。",
    th: "Procedure notes with principles, aftercare, and case insights.",
  },
  defaultKeywords: {
    ko: ["시술 노트", "피부 시술", "레이저", "리프팅", "토닝", "제모", "여드름", "흉터", "색소"],
    en: ["procedure notes", "dermatology", "laser", "lifting", "toning", "hair removal", "acne", "scar", "pigmentation"],
    ja: ["施術ノート", "皮膚", "レーザー", "リフティング", "トーニング", "脱毛", "ニキビ", "瘢痕", "色素"],
    zh: ["项目笔记", "皮肤", "激光", "提升", "嫩肤", "脱毛", "痤疮", "疤痕", "色素"],
    th: ["บันทึกหัตถการ", "ผิวหนัง", "เลเซอร์", "ยกกระชับ", "โทนนิ่ง", "กำจัดขน", "สิว", "แผลเป็น", "เม็ดสี"],
  },
    },
    clinicPriceDetail: {
  baseDesc: {
    ko: "시술 상세 정보입니다.",
    en: "Procedure details page.",
    ja: "施術の詳細ページです。",
    zh: "项目详情页面。",
    th: "หน้ารายละเอียดทรีตเมนต์",
  },
  defaultKeywords: {
    ko: ["구로 끗 한의원", "구로디지털단지 피부과 시술", "구로 레이저", "구로 리프팅", "구로 여드름", "구로 제모", "구로 피부과", "구로디지털단지역 한의원"],
    en: ["guro treatment", "guro skin clinic", "guro laser clinic", "korean skin clinic guro"],
    ja: ["九老 施術", "九老 美容クリニック", "九老 レーザー", "韓国 美容 クリニック 九老"],
    zh: ["九老 皮肤科", "九老 美容诊所", "九老 激光 项目", "韩国 九老 韩医院"],
    th: ["การรักษา กูโร", "คลินิก เกาหลี", "เลเซอร์ กูโร", "ยกกระชับ กูโร"],
  },
  areaServed: "Seoul—Guro",
    },
    uncoveredFees: {
  keywords: {
  ko: ["비급여 진료비용", "비급여 안내", "시술 비용", "끗 한의원 비용"],
  en: ["non-covered fees", "korean clinic price", "kkeut clinic fee guide"],
  ja: ["保険外診療費", "施術費用", "韓医院 費用"],
  zh: ["非医保费用", "诊疗费用", "韩医院价格"]
},
    },
    reserve: {
  keywords: {
  ko: ["예약", "시술예약", "구로", "한의원", "상담"],
  en: ["reservation", "booking", "clinic", "Guro", "consultation"],
  ja: ["予約", "施術予約", "クリニック", "九老", "相談"],
  zh: ["预约", "项目预约", "诊所", "九老", "咨询"],
  th: ["จอง", "จองทรีตเมนต์", "คลินิก", "กูโร", "ปรึกษา"]
},
  robots: { index: false, follow: false },
    },
    doctors: {
  google: "XF8flFzVlpsFvV77lP0fpAZXzczItrs03Mtzuoa4d4U",
  fallbackRegion: "구로",
  keywords: [
    "원장 소개",
    "의료진 소개",
    "구로 한의원",
    "구로디지털단지 한의원",
    "구로 피부과",
    "레이저 제모",
    "리프팅",
    "다이어트 한의원",
    "끗 한의원",
  ],
    },
    rssNote: {
      // 이 지점만 태국어까지 넘기고 있었다 — 페이지 인라인에서 옮김 (#861).
      supported: ["ko", "en", "ja", "zh", "th"],
  keywords: {
    ko: [
      "한의원 원장 소개",
      "구로 피부과",
      "구로디지털단지 피부과",
      "구로 한의원",
      "구로디지털단지 한의원",
      "구로 슈링크",
      "인모드",
      "남자 레이저 제모",
      "토닝",
      "흉터",
      "점제거",
      "아포지 플러스",
      "실리프팅",
      "여드름",
      "탄력",
      "기미",
      "색소",
      "문신제거",
      "비만",
      "체형",
      "지방분해주사",
      "윤곽주사",
      "구로디지털단지 보톡스",
      "끗 한의원 의료진",
      "구로 피부 진료",
      "리프팅 한의원",
      "약침 시술",
      "다이어트 한의원",
    ],
    en: [
      "Korean medicine clinic",
      "dermatology",
      "Guro",
      "Guro Digital Complex",
      "lifting",
      "aesthetics",
      "diet clinic",
      "acne",
      "botox",
      "filler",
      "laser hair removal",
      "tattoo removal",
      "skin toning",
      "apogee elite plus",
      "thread lift",
      "pharmacopuncture",
    ],
    ja: [
      "韓方クリニック",
      "皮膚科",
      "九老",
      "九老デジタル団地",
      "リフティング",
      "美容",
      "ダイエット外来",
      "ニキビ",
      "ボトックス",
      "フィラー",
      "医療脱毛",
      "タトゥー除去",
      "トーニング",
      "スレッドリフト",
      "薬鍼",
    ],
    zh: [
      "韩方诊所",
      "皮肤科",
      "九老",
      "九老数码园区",
      "提升",
      "医美",
      "减脂",
      "痘痘",
      "肉毒",
      "玻尿酸",
      "激光脱毛",
      "纹身去除",
      "调色激光",
      "线雕",
      "药针疗法",
    ],
  },
    },
    before: {
      // 이 지점만 태국어까지 넘기고 있었다 — 페이지 인라인에서 옮김 (#863).
      supported: ["ko", "en", "ja", "zh", "th"],
  baseDesc: {
    ko: "{{TAIL}}에서 실제 시술을 받은 고객들의 리프팅, 여드름, 다이어트 등의 Before & After 사진을 확인해보세요. 진짜 사례로 신뢰를 확인할 수 있습니다.",
    en: "See real lifting, acne and diet Before & After cases from {{TAIL}}. Verify with real results.",
    ja: "{{TAIL}}の実際の症例（リフティング・ニキビ・ダイエット）のビフォー＆アフターをご覧ください。リアルな結果でご確認いただけます。",
    zh: "在{{TAIL}}查看真实案例的前后对比（提升、痘痘、减脂等），以真实效果为依据。",
    th: "ดูเคสรีวิวก่อน-หลังจริงของการยกกระชับ สิว และลดน้ำหนักจาก {{TAIL}} ตรวจสอบผลลัพธ์จริงได้ที่นี่",
  },
  keywords: {
    ko: ["전후사진","리프팅","피부과","시술","보톡스","필러","다이어트","여드름"],
    en: ["before and after","lifting","dermatology","treatment","botox","filler","diet","acne"],
    ja: ["ビフォーアフター","前後比較","リフティング","皮膚科","治療","ボトックス","フィラー","ダイエット","ニキビ"],
    zh: ["前后对比","术前术后","提升","皮肤科","治疗","肉毒","玻尿酸","减脂","痘痘"],
    th: ["รีวิว","ก่อนหลัง","ภาพจริง","Shurink","InMode","สิว","แผลเป็น","ลดน้ำหนัก"],
  },
  pageLabel: {
    ko: "전후 사진",
    zh: "前后对比",
    th: "รีวิวก่อน-หลัง",
  },
    },
    blogNote: {
      // 이 지점만 태국어까지 넘기고 있었다 — 페이지 인라인에서 옮김 (#861).
      supported: ["ko", "en", "ja", "zh", "th"],
  baseDesc: {
    ko: "구로본점 끗 한의원 원장 블로그. 시술 원리, 케이스 인사이트, 사후 관리 팁 등 유익한 내용을 정리했습니다.",
    en: "KKEUT Clinic director's blog in Seoul: treatment principles, case insights, and aftercare tips.",
    ja: "ソウルのKKEUT韓医院 院長ブログ。施術原理、ケースの洞察、アフターケアのヒントをまとめています。",
    zh: "首尔 KKEUT韩医院 院长博客：项目原理、案例洞见与术后护理要点。",
    th: "บล็อกของผู้อำนวยการคลินิก KKEUT ในโซล: หลักการรักษา, ข้อมูลเชิงลึกของเคส, และเคล็ดลับการดูแลหลังการรักษา",
  },
  keywords: {
    ko: ["원장 블로그", "피부 시술", "레이저", "리프팅", "토닝", "제모", "여드름", "흉터", "색소", "구로 피부과", "구로디지털단지 피부과"],
    en: ["doctor blog", "dermatology", "laser", "lifting", "toning", "hair removal", "acne", "scar", "pigmentation", "Seoul skin clinic"],
    ja: ["院長ブログ", "皮膚科", "レーザー", "リフティング", "トーニング", "脱毛", "ニキビ", "瘢痕", "色素"],
    zh: ["院长博客", "皮肤科", "激光", "提升", "嫩肤", "脱毛", "痤疮", "疤痕", "色素"],
    th: [
      "บันทึกการรักษา",
      "รีวิว",
      "ผลข้างเคียง",
      "ข้อควรระวัง",
      "ระยะเวลาพักฟื้น",
      "คู่มือการรักษา",
      "คลินิกผิวหนัง",
      "คลินิก KKEUT",
    ],
  },
  pageLabel: {
    zh: "疗程笔记",
    th: "บันทึกการรักษา",
  },
    },
    kkeut: {
      // 이 지점만 태국어까지 넘기고 있었다 — 페이지 인라인에서 옮김 (#863).
      supported: ["ko", "en", "ja", "zh", "th"],
  defaultDesc: {
    ko: "피부·다이어트·리프팅 중심의 맞춤 한방 진료를 제공합니다. 병원 철학, 진료 방향, 시설 정보를 확인해보세요.",
    en: "A Korean medicine clinic focused on skin, diet and lifting. Read about our philosophy, care approach and facilities.",
    ja: "皮膚・ダイエット・リフティングに特化した韓方クリニック。理念・診療方針・施設情報をご覧ください。",
    zh: "专注于皮肤、减肥与提升的韩医诊所。查看我们的理念、诊疗方向与设施信息。",
    th: "คลินิกแพทย์แผนเกาหลีที่เชี่ยวชาญด้านผิวพรรณ ลดน้ำหนัก และยกกระชับ อ่านปรัชญา แนวทางการรักษา และข้อมูลสิ่งอำนวยความสะดวกของเรา",
  },
  defaultKw: {
    ko: ["한의원 소개", "병원 철학", "구로 한의원", "구로디지털단지 한의원", "피부과", "리프팅", "약침", "레이저토닝", "제모", "여드름", "스킨부스터", "보톡스", "필러", "끗 한의원"],
    en: ["KKEUT Clinic", "Guro clinic", "Korean medicine", "dermatology", "diet", "lifting", "acupuncture", "laser toning", "hair removal", "acne", "skin booster", "botox", "filler"],
    ja: ["九老 クリニック", "韓方", "皮膚", "ダイエット", "リフティング", "鍼", "レーザートーニング", "脱毛", "ニキビ", "スキンブースター", "ボトックス", "フィラー"],
    zh: ["九老 韩医院", "韩国传统医学", "皮肤", "减肥", "提升", "针灸", "激光焕肤", "脱毛", "痘痘", "皮肤补剂", "肉毒", "玻尿酸"],
    th: ["กูโร คลินิก", "แพทย์แผนเกาหลี", "ผิวหนัง", "ลดน้ำหนัก", "ยกกระชับ", "ฝังเข็ม", "เลเซอร์โทนนิ่ง", "กำจัดขน", "สิว", "สกินบูสเตอร์", "โบท็อกซ์", "ฟิลเลอร์"],
  },
    },
    skinNote: {
      // 이 지점만 태국어까지 넘기고 있었다 — 페이지 인라인에서 옮김 (#863).
      supported: ["ko", "en", "ja", "zh", "th"],
  baseDesc: {
    ko: "끗 한의원의 시술 노트와 케이스 인사이트, 관리 팁을 한 곳에서 확인할 수 있습니다.",
    en: "Explore KKEUT Clinic procedure notes, case insights, and aftercare tips.",
    ja: "KKEUT韓医院の施術ノート、ケースインサイト、アフターケア情報をご覧いただけます。",
    zh: "查看 KKEUT 韩医院的施术笔记、案例洞察与护理提示。",
    th: "ดูบันทึกการรักษา เคสตัวอย่าง และคำแนะนำการดูแลหลังทำของ KKEUT Clinic",
  },
  keywords: {
    ko: ["시술 노트", "피부 시술", "레이저", "리프팅", "제모", "피부관리"],
    en: ["procedure notes", "skin treatment", "laser", "lifting", "hair removal"],
    ja: ["施術ノート", "美容施術", "レーザー", "リフティング", "脱毛"],
    zh: ["施术笔记", "皮肤治疗", "激光", "提升", "脱毛"],
    th: ["บันทึกการรักษา", "เลเซอร์", "ยกกระชับ", "กำจัดขน", "ดูแลผิว"],
  },
  siteName: {
    ko: "끗 한의원",
    en: "KKEUT Clinic",
    ja: "KKEUT韓医院",
    zh: "KKEUT韩医院",
    th: "KKEUT Clinic",
  },
    },
    network: {
  fallbackDomain: "https://www.kkeutclinic.co.kr"
,
  naver: "11aeebaa1b78d629deb7252b952bc514575d05c0",
  google: "XF8flFzVlpsFvV77lP0fpAZXzczItrs03Mtzuoa4d4U",
    },
    clinicPrice: {
      supported: ["ko", "en", "ja", "zh", "th"],
  baseDesc: {
    ko: "구로본점 끗 한의원의 다양한 시술 안내와 이벤트 정보를 확인해 보세요. 최신 프로모션과 시술별 상세 설명을 제공합니다.",
    en: "Explore treatments and promotions at KKEUT Clinic (Guro). Find detailed information for each procedure.",
    ja: "九老のKKEUT韓医院の施術案内とイベント情報をご覧ください。各施術の詳細も掲載しています。",
    zh: "查看九老KKEUT韩医院的项目与活动信息，了解各项目的详细说明。",
    th: "ดูข้อมูลทรีตเมนต์และโปรโมชันของ KKEUT Clinic (สาขากูโร) พร้อมรายละเอียดของแต่ละหัตถการ",
  },
  keywords: {
    ko: [
      "구로 올리지오",
      "구로 슈링크",
      "구로 보톡스",
      "구로 필러",
      "구로 레이저토닝",
      "구로 제모",
      "구로 쥬베룩",
      "구로 리쥬란",
      "구로 피부과 이벤트",
    ],
    en: [
      "Guro Ulthera",
      "Guro Shurink",
      "Guro botox",
      "Guro filler",
      "laser toning Guro",
      "hair removal Guro",
      "Rejuran Guro",
      "skin clinic event",
    ],
    ja: [
      "九老 ボトックス",
      "九老 フィラー",
      "九老 レーザートーニング",
      "九老 脱毛",
      "九老 リジュラン",
      "皮膚科 イベント",
    ],
    zh: ["九老 肉毒", "九老 玻尿酸", "九老 激光嫩肤", "九老 脱毛", "九老 丽珠兰", "皮肤科 活动"],
    th: [
      "กูโร โบท็อกซ์",
      "กูโร ฟิลเลอร์",
      "เลเซอร์โทนนิ่ง กูโร",
      "กำจัดขน กูโร",
      "รีจูรัน กูโร",
      "คลินิกผิวหนัง โปรโมชัน",
    ],
  },
  naver: "11aeebaa1b78d629deb7252b952bc514575d05c0",
  google: "XF8flFzVlpsFvV77lP0fpAZXzczItrs03Mtzuoa4d4U",
    },
  },


  // config/branch.js 에 있던 지점 정보 (#851).

  // 본인인증 수단 — 지점 단일 출처 (#835).
  // 예약·예약확인·비대면예약·전후사진·마이페이지가 모두 이 값 하나를 쓴다.
  // 화면마다 따로 두었더니 같은 지점 안에서도, 언어별로도 값이 갈렸다.
  ivChannels: ["kakao","sms"],
  branchName: { ko: "구로점", en: "Guro", ja: "九老店", zh: "九老店", th: "สาขากูโร" },
  domain: "www.kkeutclinic.co.kr",
  phone: "02-6959-6080",
  // 구조화 데이터(JSON-LD)의 좌표. 라이브 지도가 Firestore 주소
  // "서울 관악구 시흥대로 552" 를 카카오로 지오코딩한 값이다 — 레이아웃에
  // 박혀 있던 37.4839/126.8973 은 구로구 디지털로 쪽으로 400m 쯤 틀렸다.
  geo: { latitude: 37.4821208740528, longitude: 126.901415809881 },
  // location / businessHours / social / menu 등은
  // 후속 컴포넌트 추출 시점에 채워 넣음 (Footer, Location 등 작업 단계).
  locales: ["ko", "en", "ja", "zh", "th"],
  defaultLocale: "ko",

  // 끗차트(EMR) 연동 스위치 — Reserve.jsx(CHART_ENABLED)가 이 파일(@/config/branch)을 읽음.
  // 활성 전제: 차트 프로비저닝(지점·상담카테고리 isPartner·API키) + Vercel env(CHART_API_*).
  // DrPalette 흐름은 코드상 보존되나 enabled=true 라 실행되지 않음(휴면).
  // 비대면예약 화면 (#835)
  remote: {
  },

};
